import React, { useState, Fragment, useEffect } from 'react';
import {
    Row, Col, Card, Input, Label, Button, CardBody, CardHeader, Spinner,
    UncontrolledTooltip, Table, Nav, NavItem, NavLink, TabContent, TabPane
} from 'reactstrap';
import { Controller, useForm } from 'react-hook-form';
import { Download } from 'react-feather';
import Select, { SingleValue } from 'react-select';
import websocket_webservice from '../../../Service/websocket_webservice';
import { AesDecrypt, AesEncrypt, keyPromise } from '../../../Service/crypto';
import webservice from '../../../Service/webservice';
import classnames from 'classnames';
import api from '../../../api';

interface Iinsuranceoption {
    label: string;
    value: string;
}
interface Patientoption {
    label: string;
    value: string;
    key: string;
    folder_path: string;
    templateId: string;
    memberid: string;
}
interface FormValues {
    Input: string;
}
const defaultValues: FormValues = {
    Input: '',
};
interface IClientOption {
    label: string;
    value: string;
}

const PromptPage: React.FC = () => {
    const {
        control,
        handleSubmit,
        setValue,
        setError,
        formState: { errors },
    } = useForm<FormValues>({ defaultValues });

    const [responseData, setResponseData] = useState<Record<string, any> | null>(null);
    const [rawResponseData, setRawResponseData] = useState<string | null>(null);
    const [inputValue, setInputValue] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [finalloading, setfinalloading] = useState<boolean>(false);

    const [clientOptions, setClientOptions] = useState<IClientOption[]>([]);
    const [selectedClientId, setSelectedClientId] = useState<string>('');
    const [selectedClient, setSelectedClient] = useState<string>('');

    const [insuranceoption, setInsurance] = useState<Iinsuranceoption[]>([]);
    const [SelectedInsuranceId, setSelectedInsuranceId] = useState<string>('');
    const [SelectedInsurancename, setSelectedInsurance] = useState<string>('');

    const [PatientOption, setPatientOption] = useState<Patientoption[]>([]);
    const [selectedPatientId, setselectedPatientId] = useState<string>('');
    const [selectedPatient, setselectedPatient] = useState<string>('');
    const [selectedfolder_path, setselectedfolder_path] = useState<string>('');
    const [selectedtemplateId, setselectedtemplateId] = useState<string>('');

    // Tabs
    const [activeTab, setActiveTab] = useState<'initial' | 'final'>('initial');

    // Final prompt state
    const [finalPromptInput, setFinalPromptInput] = useState('');
    const [finalResponse, setFinalResponse] = useState<Record<string, any> | null>(null);

    useEffect(() => {
        const fetchRoleId = async () => {
            const key = await keyPromise;
            const response = await api.fetch('api/BulkUpload/companyname', {
                method: 'POST'
            }).then((res) => res.json());

            const TempData = await AesDecrypt(key, response);
            const res = TempData.map((data: any) => ({
                label: data.CompanyName,
                value: data.id,
            }));
            setClientOptions(res);
        };

        fetchRoleId();
        const socket = new WebSocket(`${websocket_webservice}ws/ClientDropdown/`);
        socket.onmessage = () => fetchRoleId();
        return () => {
            if (socket.readyState === 1) socket.close();
        };
    }, []);

    useEffect(() => {
        if (!selectedClientId) return;
        const get_Insurance = async () => {
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, selectedClientId);
            const response = await api.fetch('api/Insurancename', {
                method: 'POST',
                body: JSON.stringify({ EncParams }),
            });
            const data = await response.json();
            const TempData = await AesDecrypt(key, data);
            return TempData;
        };

        const fetchinsurance = async () => {
            const response = await get_Insurance();
            const res = response.map((data: any) => ({
                label: data.name,
                value: data.name,
            }));
            setInsurance(res);
        };

        fetchinsurance();
        const socket = new WebSocket(`${websocket_webservice}ws/InsuranceDropdown/`);
        socket.onmessage = () => fetchinsurance();
        return () => {
            if (socket.readyState === 1) socket.close();
        };
    }, [selectedClientId]);

    const handleSelectClientChange = (selectedOption: SingleValue<IClientOption>) => {
        if (selectedOption) {
            setSelectedClient(selectedOption.label);
            setSelectedClientId(selectedOption.value);
        } else {
            setSelectedClient('');
            setSelectedClientId('');
        }
        setSelectedInsurance('');
        setSelectedInsuranceId('');
        setselectedPatient('');
        setselectedPatientId('');
        setselectedfolder_path('');
        setselectedtemplateId('');
        setResponseData(null);
        setInsurance([]);
        setPatientOption([]);
    };

    const handleInsuranceChange = async (selectedOption: SingleValue<Iinsuranceoption>) => {
        if (selectedOption) {
            setSelectedInsurance(selectedOption.label);
            setSelectedInsuranceId(selectedOption.value);
            try {
                const key = await keyPromise;
                const payload = {
                    client_id: selectedClientId,
                    insurance_name: selectedOption.label,
                };
                const EncParams = await AesEncrypt(key, payload);
                const response = await api.fetch('api/promptesting/getPatientDetails', {
                    method: 'POST',
                    body: JSON.stringify({ EncParams }),
                });
                const result = await response.json();
                const decryptedData = await AesDecrypt(key, result);
                const res = decryptedData.map((data: any) => ({
                    label: data.Patientname,
                    value: data.id,
                    key: data.PatientDOB,
                    memberid: data.Memberid,
                    templateId: data.templateId,
                    folder_path: data.folder_path
                }));
                setPatientOption(res);
            } catch (error) {
                console.error("Error fetching patient details:", error);
            } finally {
                setLoading(false);
            }
        } else {
            setSelectedInsurance('');
            setSelectedInsuranceId('');
            setselectedPatient('');
            setselectedPatientId('');
            setselectedfolder_path('');
            setselectedtemplateId('');
            setResponseData(null);
            setPatientOption([]);
        }
    };

    const handlePatientChange = (selectedOption: SingleValue<Patientoption>) => {
        if (selectedOption) {
            setselectedPatient(selectedOption.label);
            setselectedPatientId(selectedOption.value);
            setselectedfolder_path(selectedOption.folder_path);
            setselectedtemplateId(selectedOption.templateId);
        } else {
            setselectedPatient('');
            setselectedPatientId('');
            setselectedfolder_path('');
            setselectedtemplateId('');
            setResponseData(null);
        }
    };

    const handleDownload = () => {
        const now = new Date();
        const formattedDate = now.toISOString().replace(/[:.]/g, '-');
        const fileName = `data_${formattedDate}.txt`;
        const fileContent = `\n${selectedPatient}\n\nInput Value:\n${inputValue}\n\nResponse Data:\n${JSON.stringify(responseData, null, 2)}`;
        const blob = new Blob([fileContent], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    };
    const FinaldatadownloadhandleDownload = () => {
        const now = new Date();
        const formattedDate = now.toISOString().replace(/[:.]/g, '-');
        const fileName = `Final_data_${formattedDate}.txt`;
        const fileContent = `\n${selectedPatient}\n\nInput Value:\n${inputValue}\n\nResponse Data:\n${JSON.stringify(finalResponse, null, 2)}`;
        const blob = new Blob([fileContent], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    };

    const onSubmit = async (data: FormValues) => {
        const { Input } = data;
        if (!Input) {
            setError('Input', { type: 'manual', message: 'Please enter the input' });
            return;
        }
        if (!selectedClientId || !SelectedInsuranceId) {
            alert("Please select Client and Insurance.");
            return;
        }
        setInputValue(Input);
        setLoading(true);
        try {
            const key = await keyPromise;
            const payload = {
                prompt_input: Input,
                template_id: selectedtemplateId || null,
                folder_path: selectedfolder_path,
                final_prompt_execute: false
            };

            const EncParams = await AesEncrypt(key, payload);
            const response = await fetch('https://genai.dentagenix.com/api/promptTesting/', {
            // const response = await fetch('http://192.168.0.47:8060/api/promptTesting/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ EncParams }),
            }).then((res) => res.json());

            const TempData = await AesDecrypt(key, response);

            if (TempData.status === "A") {

                setRawResponseData(TempData.raw_outputs);
                setResponseData(TempData.patient_details);
                const datatoken = TempData.patient_details;
                const tempdata = {
                    input_token: datatoken.input_token_count,
                    outputtoken: datatoken.output_token_count,
                    modelname: datatoken.model_name,
                };
                const EncParams = await AesEncrypt(key, tempdata);
                await api.fetch('api/prompttesting/token_save_data', {
                    method: 'POST',
                    body: JSON.stringify({ EncParams }),
                });
            } else {
                setResponseData(TempData.error);
            }
        } catch (error) {
            console.error("Error submitting prompt:", error);
        } finally {
            setLoading(false);
        }
    };

    // === Final prompt handler ===
    const handleFinalSubmit = async () => {
        if (!finalPromptInput) {
            alert("Please enter final prompt input");
            return;
        }
        setfinalloading(true);
        try {
            const key = await keyPromise;
            const payload = {
                final_prompt_input: finalPromptInput,
                folder_path: selectedfolder_path,
                template_id: selectedtemplateId,
                final_prompt_execute: true,
                old_raw_output: rawResponseData
            };

            const EncParams = await AesEncrypt(key, payload);
            // const response = await fetch('http://192.168.0.47:8060/api/promptTesting/', {
            const response = await fetch('https://genai.dentagenix.com/api/promptTesting/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ EncParams }),
            }).then((res) => res.json());

            const TempData = await AesDecrypt(key, response);
            setFinalResponse(TempData.patient_details);
        } catch (error) {
            console.error("Error submitting final prompt:", error);
        } finally {
            setfinalloading(false);
        }
    };

    const DataResponse: React.FC<{ data: Record<string, any> }> = ({ data }) => (
        <Card className="p-3">
            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <Table bordered striped responsive>
                    <tbody>
                        {Object.entries(data).map(([key, value]) => (
                            <tr key={key}>
                                <th style={{ width: '40%' }}>{key}</th>
                                <td>{String(value)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </Card>
    );

    return (
        <Fragment>
            <Row className="justify-content-center">
                <Col md="12">
                    <Card>
                        <CardHeader style={{ backgroundColor: '#1f2f3e' }} className="d-flex justify-content-center align-items-center">
                            <h2 style={{ color: 'white' }}>Prompt Testing</h2>
                            {responseData && activeTab === 'initial' && (
                                <>
                                    <Button
                                        color="success"
                                        className="btn-icon rounded-circle"
                                        style={{ position: 'absolute', right: '30px' }}
                                        onClick={handleDownload}
                                        id="positionTop"
                                    >
                                        <Download size={18} />
                                    </Button>
                                    <UncontrolledTooltip placement="left" target="positionTop">
                                        <span style={{ color: 'orange' }}>Download Text File</span>
                                    </UncontrolledTooltip>
                                </>
                            )}
                            {finalResponse && activeTab === 'final' && (
                                <>
                                    <Button
                                        color="success"
                                        className="btn-icon rounded-circle"
                                        style={{ position: 'absolute', right: '30px' }}
                                        onClick={FinaldatadownloadhandleDownload}
                                        id="positionTop"
                                    >
                                        <Download size={18} />
                                    </Button>
                                    <UncontrolledTooltip placement="left" target="positionTop">
                                        <span style={{ color: 'orange' }}>Download Text File</span>
                                    </UncontrolledTooltip>
                                </>
                            )}
                        </CardHeader>

                        <CardBody>
                            {/* Tabs */}
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === 'initial' })}
                                        onClick={() => setActiveTab('initial')}
                                    >
                                        Initial Prompt
                                    </NavLink>
                                </NavItem>
                                {responseData && (
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === 'final' })}
                                            onClick={() => {
                                                setFinalPromptInput(finalPromptInput || '');
                                                setActiveTab('final');
                                            }}
                                        >
                                            Final Prompt
                                        </NavLink>
                                    </NavItem>
                                )}
                            </Nav>

                            <TabContent activeTab={activeTab} className="mt-3">
                                {/* Initial Prompt Tab */}
                                <TabPane tabId="initial">
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <Row className="gy-2">
                                            <Col xl={3}>
                                                <Label className="form-label">Select Client <span style={{ color: "red" }}>*</span></Label>
                                                <Select
                                                    isClearable
                                                    options={clientOptions}
                                                    classNamePrefix="select"
                                                    placeholder="Type Here"
                                                    value={selectedClientId ? { value: selectedClientId, label: selectedClient } : null}
                                                    onChange={(option) => handleSelectClientChange(option)}
                                                />
                                            </Col>
                                            <Col xl={3}>
                                                <Label className="form-label">Select Insurance <span style={{ color: "red" }}>*</span></Label>
                                                <Select
                                                    isClearable
                                                    options={insuranceoption}
                                                    classNamePrefix="select"
                                                    placeholder="Type Here"
                                                    value={SelectedInsuranceId ? { value: SelectedInsuranceId, label: SelectedInsurancename } : null}
                                                    onChange={(option) => handleInsuranceChange(option)}
                                                />
                                            </Col>
                                            <Col xl={3}>
                                                <Label className="form-label">Patient <span style={{ color: "red" }}>*</span></Label>
                                                <Select
                                                    isClearable
                                                    options={PatientOption}
                                                    classNamePrefix="select"
                                                    placeholder="Type Here"
                                                    value={selectedPatientId ? PatientOption.find(p => p.value === selectedPatientId) || null : null}
                                                    onChange={(option) => handlePatientChange(option)}
                                                />
                                            </Col>
                                            <Col md="12">
                                                <Label for="Input">Prompt</Label>
                                                <Controller
                                                    name="Input"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <Input
                                                            type="textarea"
                                                            {...field}
                                                            id="Input"
                                                            placeholder="Enter Input"
                                                            invalid={!!errors.Input}
                                                            style={{ minHeight: '150px' }}
                                                        />
                                                    )}
                                                />
                                                {errors.Input && <p className="text-danger">{errors.Input.message}</p>}
                                            </Col>
                                            <Col md="12">
                                                {!loading ? (
                                                    responseData ? (
                                                        <DataResponse data={responseData} />
                                                    ) : (
                                                        <Card className="p-3">No Data Available</Card>
                                                    )
                                                ) : null}
                                            </Col>
                                            {loading && (
                                                <Row className="justify-content-center mt-3">
                                                    <Col className="text-center">
                                                        <Spinner color="primary" />
                                                        <p>Loading...</p>
                                                    </Col>
                                                </Row>
                                            )}
                                            {selectedPatient && (
                                                <Row className="d-flex justify-content-center mt-3">
                                                    <Button style={{ width: '150px' }} color="success" type="submit" size="sm">
                                                        Test
                                                    </Button>
                                                </Row>
                                            )}
                                        </Row>
                                    </form>
                                </TabPane>

                                {/* Final Prompt Tab */}
                                <TabPane tabId="final">
                                    <Row>
                                        <Col md="12">
                                            <Label for="FinalPromptInput">Final Prompt Input</Label>
                                            <Input
                                                type="textarea"
                                                id="FinalPromptInput"
                                                value={finalPromptInput}
                                                onChange={(e) => setFinalPromptInput(e.target.value)}
                                                style={{ minHeight: '150px' }}
                                            />
                                        </Col>

                                        <Col md="12" className="mt-4">
                                            {finalloading ? (
                                                <Row className="justify-content-center mt-3">
                                                    <Col className="text-center">
                                                        <Spinner color="primary" />
                                                        <p>Loading...</p>
                                                    </Col>
                                                </Row>
                                            ) : finalResponse ? (
                                                <DataResponse data={finalResponse} />
                                            ) : (
                                                <Card className="p-3">No Final Data Available</Card>
                                            )}
                                        </Col>
                                        <Col md="12" className="d-flex justify-content-center mt-3">
                                            {/* <Button color="secondary" onClick={() => setActiveTab('initial')}>Back</Button> */}
                                            <Button color="primary" onClick={handleFinalSubmit}>Final Testing</Button>
                                        </Col>
                                       
                                    </Row>
                                </TabPane>
                            </TabContent>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
};

export default PromptPage;
